export const Printer = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 12V4H24V12" stroke="currentColor" stroke-width="2"/>
<path d="M8 24H4C3.44772 24 3 23.5523 3 23V13C3 12.4477 3.44772 12 4 12H28C28.5523 12 29 12.4477 29 13V23C29 23.5523 28.5523 24 28 24H24" stroke="currentColor" stroke-width="2"/>
<rect x="8" y="18" width="16" height="10" stroke="currentColor" stroke-width="2"/>
</svg>`;
